import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { Period } from '@/core/shared/types'

export type ViewMode = 'table' | 'cards'

export interface CustomDateRange {
  startDate: string
  endDate: string
}

interface DashboardState {
  selectedPeriod: Period
  setSelectedPeriod: (period: Period) => void
  customDateRange: CustomDateRange | null
  setCustomDateRange: (dateRange: CustomDateRange | null) => void
  viewMode: ViewMode
  setViewMode: (viewMode: ViewMode) => void
}

const isLocalStorageAvailable = (): boolean => {
  return typeof window !== 'undefined' && window.localStorage !== null
}

const safeLocalStorage = {
  getItem: (key: string) => {
    if (isLocalStorageAvailable()) {
      return window.localStorage.getItem(key)
    }
    return null
  },
  setItem: (key: string, value: string) => {
    if (isLocalStorageAvailable()) {
      window.localStorage.setItem(key, value)
    }
  },
  removeItem: (key: string) => {
    if (isLocalStorageAvailable()) {
      window.localStorage.removeItem(key)
    }
  },
}

export const useDashboardStore = create<DashboardState>()(
  persist(
    (set) => ({
      selectedPeriod: Period.Today,
      setSelectedPeriod: (period: Period) => set({ selectedPeriod: period }),
      customDateRange: null,
      setCustomDateRange: (dateRange: CustomDateRange | null) =>
        set({ customDateRange: dateRange }),
      viewMode: 'cards',
      setViewMode: (viewMode: ViewMode) => set({ viewMode }),
    }),
    {
      name: 'garupa-dashboard-storage',
      storage: createJSONStorage(() => safeLocalStorage),
      partialize: (state) => ({
        selectedPeriod: state.selectedPeriod,
        customDateRange: state.customDateRange,
        viewMode: state.viewMode,
      }),
    }
  )
)
